import {
  $isDecoratorBlockNode,
  DecoratorBlockNode,
} from "@lexical/react/LexicalDecoratorBlockNode";
import { TableNode } from "@lexical/table";
import { $insertNodeToNearestRoot } from "@lexical/utils";
import { $getSelection, $insertNodes, $isNodeSelection, type LexicalNode } from "lexical";

export function $insertNode(node: LexicalNode): void {
  const selection = $getSelection();

  //prevent errors when a decorator block node is currently selected on insert
  if (
    $isNodeSelection(selection) &&
    selection.getNodes().length === 1 &&
    $isDecoratorBlockNode(selection.getNodes()[0]) &&
    $isDecoratorBlockNode(node)
  ) {
    selection.getNodes()[0]!.insertAfter(node);
    node.selectEnd();
    return;
  }

  if (node instanceof TableNode) {
    $insertNodeToNearestRoot(node);
    node.selectStart();
    return;
  }

  node instanceof DecoratorBlockNode ? $insertNodeToNearestRoot(node) : $insertNodes([node]);
}
